import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthContextProvider } from './store/auth-context';
import { PatientContextProvider } from "./store/patient-context";
import { setBackendURL, setFacilitatorAppURL } from './common/Backend';

setBackendURL(process.env.REACT_APP_BACKEND_URL)
setFacilitatorAppURL(process.env.REACT_APP_FACILITATOR_URL)

// -----------------------------------------------------------------------------
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthContextProvider>
    <PatientContextProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </PatientContextProvider>
  </AuthContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
